import React, { useEffect, useState, createContext, useContext } from 'react';
import { IntlProvider } from 'react-intl';
import enBundle from '../bundles/en';
import { createLocalizeApp } from '../i18n/i18nConfig';
import { getSupportedLocales } from '../configs';

const IntlManagetContext = createContext(null);

const IntlManager = ({ children }) => {
  const [preferedLanguage, setPreferedLanguage] = useState(
    getSupportedLocales()[0],
  );
  const [config, setConfig] = useState({
    locale: preferedLanguage,
    timeZone: undefined,
    messages: enBundle,
  });

  useEffect(() => {
    createLocalizeApp((i18nAppData, bundle) => {
      setConfig({
        locale: i18nAppData.locale,
        timeZone: i18nAppData.tz,
        messages: bundle,
      });
    }, preferedLanguage);
  }, [preferedLanguage]);

  const updateLocale = userLocale => {
    setPreferedLanguage(userLocale);
  };
  return (
    <IntlManagetContext.Provider
      value={{
        locale: preferedLanguage,
        updateLocale,
        supportedLocales: getSupportedLocales(),
      }}
    >
      <IntlProvider {...config}>{children}</IntlProvider>
    </IntlManagetContext.Provider>
  );
};

export const useIntlManger = () => {
  const ctx = useContext(IntlManagetContext);
  if (!ctx) {
    throw new Error(
      'Component should be wrapperd in IntlManager to use this hook',
    );
  }
  return ctx;
};

export default IntlManager;



// WEBPACK FOOTER //
// ./src/views/IntlManager.jsx